<template>
  <!-- 这里不能用v-if,因为小程序跳转的图标有问题,只能长期显示,然后用层级控制 -->
  <div class="footer" :style="{ 'z-index': value ? '999' : '-1' }">
    <div class="module-nav">
      <template v-if="delayShow">
        <div
          class="nav-i"
          :class="{ active: item.active }"
          v-for="(item, index) in tabBar1"
          :key="'tabBar1' + index"
          @click="handleNav(item, index)"
        >
          <img
            :src="item.active ? item.activeUrl : item.url"
            class="icon"
            alt=""
          />
          <p>{{ item.label }}</p>
        </div>
      </template>
<!--      <wx-open-launch-weapp-->
<!--        id="launch-btna"-->
<!--        style=""-->
<!--        username="gh_dd06d3279c38"-->
<!--        path="pages/partner/index"-->
<!--        env-version="release"-->
<!--      >-->
<!--        <script type="text/wxtag-template">-->
<!--          <style>-->
<!--            .myp{-->
<!--              margin: 0;-->
<!--              text-align: center;-->
<!--              font-size: 13px;-->
<!--            }-->
<!--            .nav-i {-->
<!--              display: inline-block;-->
<!--              width: 70px;-->
<!--              text-align: center;-->
<!--            }-->
<!--            .icon {-->
<!--            width:24px;-->
<!--            height:24px;}</style>-->
<!--            <div class="nav-i">-->
<!--              <img class="icon" src="https://img2.coocaa.com/ui/partner-mini-program/partner/partner-gray.png"  alt="">-->
<!--              <p class="myp">合伙人</p>-->
<!--            </div>-->
<!--        </script>-->
<!--      </wx-open-launch-weapp>-->
      <template v-if="delayShow">
        <div
          class="nav-i"
          :class="{ active: item.active }"
          v-for="(item, index) in tabBar2"
          :key="'tabBar2' + index"
          @click="handleNav(item, index)"
        >
          <img
            :src="item.active ? item.activeUrl : item.url"
            class="icon"
            alt=""
          />
          <p>{{ item.label }}</p>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'home',
  props: ['value'],
  data() {
    return {
      delayShow: false,
      active: 'home',
      tabBar1: [
        {
          label: '首页',
          path: '/store-home',
          // name: 'wap-home-o',
          url: require('@/assets/home.png'),
          activeUrl: require('@/assets/home-cur.png'),
          active: false
        },
        {
          label: '分类',
          path: '/store-classify',
          url: require('@/assets/list.png'),
          activeUrl: require('@/assets/list-cur.png'),
          // name: 'coupon-o',
          active: false
        }
      ],
      tabBar2: [
        {
          label: '购物车',
          path: '/store-shopping-car',
          // name: 'shopping-cart-o',
          url: require('@/assets/cart2.png'),
          activeUrl: require('@/assets/cart-cur.png'),
          active: false
        },
        {
          label: '我的',
          path: '/store-users',
          url: require('@/assets/user.png'),
          activeUrl: require('@/assets/user-cur.png'),
          // name: 'user-o',
          active: false
        }
      ]
    }
  },
  watch: {
    $route(to, from) {
      this.handleRoute()
    }
  },
  mounted() {
    setTimeout(() => {
      this.delayShow = true
    }, 1000)
  },
  methods: {
    handleRoute() {
      let url = this.$route.path
      let tabBarList = [this.tabBar1, this.tabBar2]
      tabBarList.forEach((tabBar) => {
        for (let i in tabBar) {
          tabBar[i]['active'] = tabBar[i]['path'] === url
        }
      })
    },
    handleNav(item, index) {
      if (!this.value) {
        return
      }
      let _self = this
      let tabBarList = [this.tabBar1, this.tabBar2]
      tabBarList.forEach((tabBar) => {
        for (let i in tabBar) {
          tabBar[i]['active'] = i === index
        }
      })
      _self.$router.push({
        path: item.path
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.myp {
  height: 20px;
  margin: 0;
  padding-bottom: 8px;
  text-align: center;
  font-size: 14px;
}

.footer {
  position: fixed;
  bottom: 0;
  z-index: 998;
  width: 100%;
  background: #ffffff;
  color: #7d7e80;
  height: 62px;
  border-top: 1px solid #eee;
}

.module-nav {
  text-align: center;
  margin-top: 10px;
}

.nav-i {
  font-size: 14px;
  color: rgb(77, 85, 93);
  display: inline-block;
  width: 80px;

  &.active {
    color: #FF4100;
  }
}

.icon {
  width: 24px;
  height: 24px;
}

.nav-i p {
  height: 20px;
  margin: 0;
  padding-bottom: 8px;
  text-align: center;
  font-size: 14px;
}
</style>
